<template>
  <div class="pa-6">
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Langue(s)</legend>
        <div>
          <div class="legalSection">
            <p class="mentionLegal">
              Veuillez indiquer la ou les langues dont
              <strong>vous possédez une connaissance appropriée</strong> pour offrir des services professionnels
            </p>
          </div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Langue(s) de pratique</th>
                  <!-- <th>Autres langue</th> -->
                  <th class="text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in getLangues" :key="index">
                  <td class="pt-4">
                    <v-autocomplete
                      v-model="item.langue"
                      :item-text="itemText"
                      :item-value="itemValue"
                      :items="listeLangues"
                      :rules="rules.TypeLangues"
                      label="Langue"
                      required
                      return-object
                    ></v-autocomplete>
                  </td>
                  <td class="text-right">
                    <v-btn icon @click="deleteRow(item)">
                      <v-icon class="clickable redIcon">mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div class="text-center mt-6 d-flex justify-lg-flex-end">
            <v-btn color="primary" @click="ajouter()">Ajouter</v-btn>
          </div>
        </div>
      </fieldset>
    </v-form>

    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!canSubmit" color="secondary" @click="saveAndContinueLater()">Enregistrer et terminer plus tard </v-btn>
      <v-btn :disabled="!canSubmit" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loader from "../Loader";
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin";
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin";

export default {
  mixins: [NavigationPageFormulaireMixin, PageReadonlyFormulaireAdmissionMixin],
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  components: {
    Loader: Loader,
  },
  data() {
    return {
      overlay: false,
      messageSelector: "",
      valid: true,
      rules: {
        TypeLangues: [(v) => (!!v && v.length != 0) || "La langue est requise"],
        AutreLangue: [(v) => (!!v && v.length != 0) || "Veuillez préciser la langue"],
        Niveau: [(v) => (!!v && v.length != 0) || "Le niveau est obligatoire"],
      },
      langues: [],
      catalogue: {
        TypeLangues: [],
        Niveau: [],
      },
      typeAutre: [],
    };
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmissionPA/GET_DEMANDEADMISSIONID",
      getLangues: "Langue/getLangues",
      listeLangues: "Catalogue/GET_LANGUE",
      listeNiveau: "Catalogue/GET_NIVEAULANGUE",
    }),
    canSubmit: function () {
      return this.valid && this.getLangues && this.getLangues.length > 0;
    },
  },
  created() {
    this.fetchItems();
  },
  methods: {
    ...mapMutations({
      addLangue: "Langue/addLangue",
      removeLangue: "Langue/removeLangue",
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      updateLangue: "Langue/updateLangue",
      createLangue: "Langue/createLangue",
      deleteLangue: "Langue/deleteLangue",
      fetchLangueByDemandeAdmissionId: "Langue/fetchLangueByDemandeAdmissionId",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading";
        this.overlay = true;

        // Catalogue Niveau
        await this.getCatalogue(1908);
        await this.getCatalogue(this.$cataloguesDesc.langue);

        if (this.demandeAdmissionId) {
          await this.fetchLangueByDemandeAdmissionId(this.demandeAdmissionId);
        }

        this.overlay = false;
      } catch (erreur) {
        console.log(erreur);
      }
    },
    save() {
      this.messageSelector = "Save";
      this.overlay = true;
      this.$refs.form.validate();

      if (this.valid && this.getLangues) {
        this.getLangues.forEach((element, index, array) => {
          if (element.langue && element.langue.lang00 != "Autre") {
            element.autreLangue = "";
          }

          if (!element.id) {
            this.createLangue(element);
          } else {
            if (this.demandeAdmissionId) {
              element.demandeAdmission = this.demandeAdmissionId;
            }
            this.updateLangue(element);
          }
        });
        this.redirect();
      }
    },
    ajouter() {
      if (this.listeLangues && this.listeLangues[0] && this.listeNiveau && this.listeNiveau[0]) {
        this.addLangue({
          id: null,
          pp: null,
          demandeAdmission: this.demandeAdmissionId,
        });
      }
    },
    async deleteRow(item) {
      this.messageSelector = "Loading";
      this.overlay = true;
      if (item.id) {
        await this.deleteLangue(item);
      } else {
        this.removeLangue(item);
      }
      this.overlay = false;
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
  },
};
</script>

<style></style>
